<template>
  <div
    class="text-48 bg-navy absolute left-1/2 -top-[30px] -ml-[30px] h-[60px] w-[60px] rounded-full font-bold md:-top-[35px] md:-ml-[35px] md:h-[70px] md:w-[70px] xl:-top-[40px] xl:-ml-[40px] xl:h-20 xl:w-20">
    <div
      class="-mt-[5px] h-full w-full text-center leading-[60px] text-white md:leading-[70px] xl:leading-[80px]">
      <slot />
    </div>
  </div>
</template>

<script>
export default {};
</script>
